import { VHeaders } from '@/models/pagedlistmodel';

export function getCampaignHeaders(vm: any): VHeaders[] {
  return [
    {
      text: vm.$parent.$t('campaigns.campaignsGrid.name') as string,
      align: 'left',
      value: 'name',
      sortable: true,
    },
    {
      text: vm.$parent.$t('campaigns.campaignsGrid.description') as string,
      align: 'left',
      value: 'description',
    },
    {
      text: vm.$parent.$t('campaigns.campaignsGrid.action') as string,
      align: 'center',
      isNotDataProp: true,
      sortable: false,
    },
  ];
}
